import { NgClass, NgTemplateOutlet } from '@angular/common';
import { HttpEventType } from '@angular/common/http';
import { Component, Input, OnDestroy, inject, input } from '@angular/core';
import { Store } from '@ngxs/store';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { DocumentResponse } from '../../model/documentResponse.model';
import { MedaViewService } from '../../modules/meda-view/meda-view.service';
import { DocumentsService } from '../../services/documents.service';
import { BaseState } from '../../state/base/base.state';

@Component({
    selector: 'com-view-referral',
    templateUrl: './com-view-referral.component.html',
    styleUrls: ['./com-view-referral.component.scss'],
    imports: [NgTemplateOutlet, NgClass, PdfViewerModule],
})
export class ComViewReferralComponent implements OnDestroy {
    private documentApi = inject(DocumentsService);
    private store = inject(Store);
    private mediaView = inject(MedaViewService);

    private referralId: string;
    readonly pdfContainerHeight = input<number | undefined>((window?.innerHeight || 850) + 50);
    readonly bgPanel = input(false);
    readonly showBorder = input(true);
    @Input() set setReferralId(referralId: string) {
        if (referralId) {
            this.isLoading = true;
            this.referralId = referralId;
            this.loadReferral(this.referralId);
        }
    }
    @Input() set reload(val: unknown) {
        if (this.referralId) {
            this.isLoading = true;
            this.loadReferral(this.referralId);
        }
    }

    // @TODO: Ignored with eslint-interactive on 2023-09-15
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Input() set setBlob(value: any) {
        if (value) {
            this.isLoading = true;
            this.documentFile = URL.createObjectURL(new Blob([value], { type: 'application/pdf' }));
        }
    }

    @Input() set setDocumentId(value: string) {
        if (value) {
            this.isLoading = true;
            this.loadReferralFromDocument(value);
        }
    }

    @Input() set setObjectURLFile(value: string) {
        if (value) {
            this.isLoading = true;
            this.documentFile = value;
        }
    }

    @Input() set setObjectFile(value: Blob) {
        if (value) {
            this.documentFileForMedaView = value;
        }
    }

    private onDestroy$ = new Subject<void>();
    // @TODO: Ignored with eslint-interactive on 2023-09-15
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public documentFile: any;
    public documentFileForMedaView: any;

    public isLoading = false;
    private bsId = this.store.selectSnapshot(BaseState.getBSId);

    ngOnDestroy(): void {
        this.onDestroy$.next();
    }

    private loadReferralFromDocument(documentId: string): void {
        this.documentApi
            .openDocument(this.bsId, documentId)
            .pipe(
                takeUntil(this.onDestroy$),
                filter(event => event.type === HttpEventType.Response),
                map((res: DocumentResponse) => {
                    return { document: new Blob([res.body], { type: res.body.type }) };
                }),
            )
            // @TODO: Ignored with eslint-interactive on 2023-09-15
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .subscribe((docReq: any) => {
                this.documentFile = URL.createObjectURL(new Blob([docReq.document], { type: 'application/pdf' }));
                this.documentFileForMedaView = docReq;
            });
    }

    private loadReferral(referralId: string): void {
        this.documentApi
            .getReferralDocument(referralId)
            .pipe(takeUntil(this.onDestroy$))
            .subscribe(blob => {
                const pdfBlob = blob as Blob;
                this.documentFile = URL.createObjectURL(pdfBlob);
                this.documentFileForMedaView = { document: pdfBlob };
                this.isLoading = false;
            });
    }

    public onAfterLoad(_event: { _pdfInfo: { numPages: number } }): void {
        this.isLoading = false;
    }

    public openDocument(): void {
        // documentFileForMedaView.document is already a Blob
        this.mediaView.openDocumentViewer({ document: this.documentFileForMedaView.document }, 'obrazec.pdf', false, true);
    }
}
